<script>
import { ref, onMounted } from 'vue'

export default {
  setup(props, { slots }) {
    const show    = ref(false)
    const mobile  = ref(false)

    const toggle = () => {
      show.value = !show.value
    }

    const scrollTo = (targetId) => {
      const head      = document.getElementById('shopify-section-layout-header')
      const headH     = head.offsetHeight
      const target    = document.querySelector(targetId)
      const rect      = target.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const targetPosition = ( rect.top + scrollTop ) - headH
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      })
    }

    const toggleMobile = () => {
      if ( window.innerWidth >= 768 ) {
        mobile.value = false
      } else {
        mobile.value = true
      }
    }

    onMounted(() => {
      toggleMobile()
      window.addEventListener( 'resize', toggleMobile, false )
    })
    
    return () => slots.default({
      show: show.value,
      mobile: mobile.value,
      toggle,
      scrollTo
    })
  }
}
</script>